var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-right": "10px",
        display: "inline-block",
        "vertical-align": "middle",
        "font-weight": "bold"
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "font-size": "14px"
          }
        },
        [
          _vm.arResultList.length > 0
            ? [
                _vm._v(" " + _vm._s(_vm.arLabel) + " "),
                _vm._l(_vm.arResultList, function(item, index) {
                  return _c("div", { key: "ar" + index }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-content": "center",
                          "padding-left": "5px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "14px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.currency) +
                                "(" +
                                _vm._s(_vm.$t("CargoMsg.Cargo_AmountTo")) +
                                "):"
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "padding-left": "3px",
                              "font-size": "14px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.amount + (item.isEnd ? "" : ";"))
                            )
                          ]
                        )
                      ]
                    )
                  ])
                })
              ]
            : _vm._e(),
          _vm.apResultList.length > 0
            ? [
                _c("span", { staticStyle: { padding: "0 3px" } }),
                _vm._v(_vm._s(_vm.apLabel) + " "),
                _vm._l(_vm.apResultList, function(item, index) {
                  return _c("div", { key: "ap" + index }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-content": "center",
                          "padding-left": "5px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "14px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.currency) +
                                "(" +
                                _vm._s(_vm.$t("CargoMsg.Cargo_AmountTo")) +
                                "):"
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "padding-left": "3px",
                              "font-size": "14px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.amount + (item.isEnd ? "" : ";"))
                            )
                          ]
                        )
                      ]
                    )
                  ])
                })
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }